import { render, staticRenderFns } from "./ItemsQuotationPage.vue?vue&type=template&id=7608ff52"
import script from "./ItemsQuotationPage.vue?vue&type=script&lang=js"
export * from "./ItemsQuotationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports